//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Preferences.js";
import "../no/Object.js";
import "../Preferences/Preferences.PartPreferences.js";
let d=[[],[[[],"GetJoggleStationaryRadius",{R_:{stationary_radius:"Expression"}},0,0],[["update_model","stationary_radius"],"SetJoggleStationaryRadius",{},2,0],[[],"GetJoggleOffsetRadius",{R_:{offset_radius:"Expression"}},0,0],[["update_model","offset_radius"],"SetJoggleOffsetRadius",{},2,0],[[],"GetJoggleDepthThreshold",{R_:{depth_threshold:"Expression"}},0,0],[["update_model","depth_threshold"],"SetJoggleDepthThreshold",{},2,0],[[],"GetJoggleDistanceThreshold",{R_:{distance_threshold:"Expression"}},0,0],[["update_model","distance_threshold"],"SetJoggleDistanceThreshold",{},2,0]],[]];
SPLM.Preferences.PartAeroSheetmetal = class extends SPLM.Object{
    constructor (owner){
        if(owner !== undefined){
            if(owner._owner !== undefined){
                super(owner._owner);
                this._owner = owner._owner;
            }
            else{
                super(owner);
                this._owner = owner;
            }
            this._d['ObjectId'] = this._owner._d['ObjectId'];
        }
        else{
            super();
        }
        this._d['Class'] = "SPLM.Preferences.PartAeroSheetmetal";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;